/** Tool ids rendered by {@link ImageFormatToolbar}. */
export const IMAGE_FORMAT_TOOLS = {
  BG_REMOVER: "bgRemover",
  SIZE: "size",
  COLOR: "color",
  STROKE: "stroke",
  ROUND_CORNER: "roundCorner",
  CROP: "crop",
  FLIP: "flip",
  EFFECT: "effect",
  OPACITY: "opacity",
  POSITION: "position",
};

/** Default image-style shape (host maps its own fields). */
export const DEFAULT_IMAGE_FORMAT = {
  size: 4.5,
  /** Tint / recolor overlay; null = no tint */
  tintColor: null,
  strokeColor: "#FFFFFF",
  /** Stroke width in px */
  strokeWidth: 0,
  /** Corner radius in px */
  cornerRadius: 0,
  /**
   * Crop aspect: custom | original | square | portrait | landscape
   * @deprecated cropInset — kept for older hosts; prefer cropRect
   */
  cropInset: 0,
  cropAspect: "custom",
  /** Normalized crop window inside the source image { x, y, w, h } */
  cropRect: null,
  /** True while the host is showing interactive crop handles */
  cropActive: false,
  /** Snapshot when crop session starts (for Cancel) */
  cropSessionStartRect: null,
  /** Natural size of the source image (for Original aspect) */
  naturalWidth: 0,
  naturalHeight: 0,
  flipH: false,
  flipV: false,
  /** none | shadow | outline | glow */
  effect: "none",
  opacity: 100,
  position: "center",
  offsetX: 0,
  offsetY: 0,
  rotation: 0,
  /** Tile layout (grid / diamond) — host maps these */
  spacing: 0.5,
  margin: 0.08,
  /** single | grid | diamond — drives Position UI mode */
  tile: "single",
  lockAspectRatio: true,
};

/** Full image toolbar tool set. */
export const IMAGE_FORMAT_TOOL_SETS = {
  default: [
    IMAGE_FORMAT_TOOLS.SIZE,
    IMAGE_FORMAT_TOOLS.COLOR,
    IMAGE_FORMAT_TOOLS.STROKE,
    IMAGE_FORMAT_TOOLS.ROUND_CORNER,
    IMAGE_FORMAT_TOOLS.CROP,
    IMAGE_FORMAT_TOOLS.FLIP,
    IMAGE_FORMAT_TOOLS.EFFECT,
    IMAGE_FORMAT_TOOLS.OPACITY,
    IMAGE_FORMAT_TOOLS.POSITION,
  ],
};

/** Shared with text toolbar — click active again to clear. */
export const IMAGE_EFFECT_OPTIONS = [
  { id: "shadow", label: "Shadow" },
  { id: "outline", label: "Outline" },
  { id: "glow", label: "Glow" },
];
